
import {CardService} from "@/modules/cards/service/CardService";
import CardInfo from "@/modules/cards/models/CardInfo";
import {Transaction} from "@/modules/cards/models/Transaction";
import {TransactionsRange} from "@/modules/cards/models/TransactionsRange";
import {Card} from "@/modules/cards/models";

export class CardPort {
    private readonly cardsService: CardService;

    constructor(params: { cardsService: CardService }) {
        this.cardsService = params.cardsService;
    }
    public async lockCard(card: any): Promise<void> {
        return this.cardsService.lockCard(card);
    }
    public async getCardUrl(card: string): Promise<string> {
        return this.cardsService.getCardUrl(card);
    }
    public async unlockCard(card: Card): Promise<void> {
        return this.cardsService.unlockCard(card);
    }
    public async transferCard(cardId: string, newCardId:string): Promise<void> {
        return this.cardsService.transferCard(cardId,newCardId);
    }
    public async getCardInfo(cardId: string): Promise<CardInfo> {
        return this.cardsService.getCardInfo(cardId);
    }
    public async getCardInfoManual(cardNr: string): Promise<CardInfo> {
        return this.cardsService.getCardInfoManual(cardNr);
    }

    public async cancelTransaction(transaction: Transaction): Promise<void> {
        return this.cardsService.cancelTransaction(transaction);
    }



    public async getReport(reportUrl:string, reportNr:number, period:number, showPeriod:boolean, range?: {start: Date, end: Date}): Promise<string> {
        return this.cardsService.getReport(reportUrl,reportNr,period,showPeriod,range);
    }
}
